import React from 'react';
import PropTypes from 'prop-types';

// Default FileInput preview component for non-image files

var propTypes = {
  name: PropTypes.string
};
var defaultProps = {
  name: ''
};
function FilePreview(_ref) {
  var name = _ref.name;
  if (!name) return null;
  return /*#__PURE__*/React.createElement("p", null, name);
}
FilePreview.propTypes = propTypes;
FilePreview.defaultProps = defaultProps;
export default FilePreview;